import { companyConstants,fileConstants,alertConstants } from '../_constants'
const initialState={
  isLoading:false,
  masterList:null,
  singleEntry:null,
  error:null,
  companyList:[],
  count:0,
  isGetAllError:false,
  deletedData:{},
  addCompanyMessage: null,
  bulkUpdateSuccessMessage:null,
  activeData:{},
  bulkUpdatResponse: null,
  fileUploadLog:[],
  fileUploadLogCount:0,
  fileLogDeleteResponse: null,
  isPageLoad:true,
  currentPage:0,
  subBrandData:null
}

export function company(state = {...initialState}, action) {
  state = {
    ...state,
    bulkUpdatResponse: null,
  }
  switch (action.type) {
  case alertConstants.CLEAR:
    return {
      ...state,
      addCompanyMessage:null,
      deletedData:{},
      activeData:{},
      bulkUpdateSuccessMessage:null,
      isGetAllError:false,
      singleEntry:null,
      bulkUpdatResponse:null,
    }
  case fileConstants.UPLOAD_SUCCESS:
    return {
      ...state,
      logoUpload: action.result,
      isLoading: false,
      addCompanyMessage: null
    }
  case companyConstants.ADD_REQUEST:
    return {
      ...state,
      messageList: action.company.message,
      isLoading: true,
      addCompanyMessage: null
    }
  case companyConstants.GETALL_SUCCESS:
    return {
      ...state,
      masterList: action.company,
      addCompanyMessage: null,
      companyList:action.company.data,
      isLoading: false
    }
  case companyConstants.ADD_SUCCESS:
    return {
      ...state,
      messageList: action.company,
      addCompanyMessage: action.company.message,
      isLoading: false,
    }
  case companyConstants.GETALL_FAILURE:
    return {
      ...state,
      error: action.error,
      isLoading:false,
      addCompanyMessage: null,
      singleEntry:{}
    }
  case companyConstants.GETALL_PAGE_REQUEST:
    return {
      ...state,
      isLoading:true,
      addCompanyMessage: null,
      bulkUpdatResponse: null,
      isPageLoad:action.company.search?false:true,
      currentPage:action.company.start
    }
  case companyConstants.GETALL_PAGE_FAILURE:
    return {
      ...state,
      error: action.error,
      isLoading:false,
      companyList:[],
      count:0,
      isGetAllError:true,
      addCompanyMessage: null
    }
  case companyConstants.GETALL_PAGE_SUCCESS:
    return {
      ...state,
      error: action.error,
      isLoading:false,
      addCompanyMessage: null,
      companyList:action.company.data,
      count:action.company.count,
      bulkUpdatResponse: null
    }
    
    case companyConstants.GETBYID_REQUEST:
      return {
        ...state,
        isLoading: true,
       }  
  case companyConstants.GETBYID_SUCCESS:
    return {
      ...state,
      singleEntry: action.result,
      isLoading: false,
      addCompanyMessage: null
    }
  case companyConstants.GETBYID_FAILURE:
    return {
      ...state,
      error: action.error,
      isLoading:false,
      addCompanyMessage: null
    }
  case companyConstants.GETALL_REQUEST:
  case companyConstants.DELETE_REQUEST:
    return {
      ...state,
      isLoading: true,
     deletedData:{},
      activeData:{},
      bulkUpdateSuccessMessage:null,
      isGetAllError:false,
      currentPage:0
    }
  case companyConstants.DELETE_SUCCESS:
    return {
      ...state,
      isLoading: false,
      deletedData: action.response,
      }
  case companyConstants.DELETE_FAILURE:
    return {
      ...state,
      isLoading :false,
      }
  case companyConstants.ACTIVE_REQUEST:
    return {
      ...state,
      isLoading: true,
      addCompanyMessage:null,
      deletedData:{},
      activeData:{},
      bulkUpdateSuccessMessage:null,
      isGetAllError:false,
      singleEntry:null,
    }
  case companyConstants.ACTIVE_SUCCESS:
    return {
      ...state,
      isLoading: false,
      activeData: action.response,
      addCompanyMessage: null
    }
  case companyConstants.ACTIVE_FAILURE:
    return {
      ...state,
      isLoading :false,
      addCompanyMessage: null
    }
  case companyConstants.BULK_ADD_FAILURE:
    return{
      ...state,
      error:action.error,
      isLoading:false,
      addCompanyMessage: null
    }
  case companyConstants.BULK_ADD_REQUEST:
    return {...state, isLoading:true,addCompanyMessage: null}
  case companyConstants.BULK_ADD_SUCCESS:
    return {...state,
      isLoading:false,
      bulkUpdateSuccessMessage: action.company.message,
      bulkUpdatResponse: action.company
    }

  case companyConstants.BULK_UPDATE_FAILURE:
    return{
      ...state,
      error:action.error,
      isLoading:false,
      addCompanyMessage: null,
      bulkUpdateSuccessMessage: null
    }
  case companyConstants.BULK_UPDATE_REQUEST:
    return {...state,
      isLoading:true,
      bulkUpdateSuccessMessage:null,
      addCompanyMessage: null}
  case companyConstants.BULK_UPDATE_SUCCESS:
    return {...state,
      isLoading:false,
      bulkUpdatResponse:action.company.data,
      bulkUpdateSuccessMessage: action.company.message}
  case companyConstants.BULK_FILE_UPLOAD_LOG_FAILURE:
    return { ...state,
      error: action.error,
      isLoading: false,
      fileUploadLog: null}
  case companyConstants.BULK_FILE_UPLOAD_LOG_REQUEST:
    return {...state,
      isLoading: true,
    }
  case companyConstants.BULK_FILE_UPLOAD_LOG_SUCCESS:
    return { ...state,
      isLoading: false,
      fileUploadLog: action.response.data,
      fileUploadLogCount:action.response.count
    }
  case companyConstants.BULK_FILE_UPLOAD_DELETE_FAILURE:
    return {
      ...state,
      error: action.error,
      isLoading: false,
      fileLogDeleteResponse: null
    }
  case companyConstants.BULK_FILE_UPLOAD_DELETE_REQUEST:
    return {
      ...state,
      isLoading: true,
      fileLogDeleteResponse: null
    }
  case companyConstants.BULK_FILE_UPLOAD_DELETE_SUCCESS:
    return {
      ...state,
      isLoading: false,
      fileLogDeleteResponse:  action.response,
    }
  case companyConstants.MESSAGE_CLEAR:
    return {
      ...state,
      isLoading: false,
      fileLogDeleteResponse:  null,
    }
    case companyConstants.UPDATE_SUB_BRAND:
      return {
        ...state,
        subBrandData: action.data,
      }  
  default:
    return state
  }
}
